export default "__VITE_ASSET__DEW55vuD__"